<template>
  <el-dialog
  title="列表控制"
  :visible.sync="visibleDialog"
  width="678px"
  top="calc(50vh - 240px)"
  class="pop-dialog pop-set-table"
  append-to-body>
  <div class="table-list-top">
    <div class="primary" @click="onResetDefault">恢复默认</div><span class="space">|</span>
    <div class="primary" @click="onShowAll">全部显示</div><span class="space">|</span>
    <div class="primary" @click="onFreezeAll">全部解冻</div>
  </div>
  <div class="table-list table-mini">
    <el-table
      :data="tableList"
      :row-class-name="tableRowClassName">
      <el-table-column
        type="index"
        label="排序"
        width="50">
      </el-table-column>
      <el-table-column
        prop="label"
        label="列名"
        width="168">
      </el-table-column>
      <el-table-column
        label="对齐方式"
        width="120">
        <template slot-scope="scope">
          <el-select v-model="scope.row.align" placeholder="请选择" size="mini" class="select-align" >
            <el-option label="居中" value="center"></el-option>
            <el-option label="左对齐" value="left"></el-option>
            <el-option label="右对齐" value="right"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="显示列" width="85">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.show" size="mini"  @change="onShowColumn">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="冻结列" width="85">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.freeze" size="mini" @change="onFreeze($event,scope.row.order)" >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作" width="120"
        >
        <template slot-scope="scope">
          <div class="btn-con">
            <div class="primary" @click="onUp(scope.$index)" v-if="scope.$index !== 0">上移</div>
            <div class="primary" @click="onDown(scope.$index)" v-if="scope.$index !== columns.length - 1">下移</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <template slot="footer">
    <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
    <el-button type="primary" @click="onConfirm" size="mini">确 定</el-button>
  </template>
</el-dialog>
</template>
<script>
import { sessionStorage } from '@/assets/js/storage'
  export default {
    name:'popSetTable',
    data () {
      return {
        visibleDialog:false,
        columns:[],
      }
    },
    computed: {
      tableList() {
        return  this.columns.filter(e=>!e.noSet)
      }
    },
    methods: {
      show(list) {
        this.visibleDialog = true
        this.columns = list
      },
      // 添加行样式类名
      tableRowClassName({row}) {
        if (row.move==1) {
          return 'row-move'
        } else if (row.move==2) {
          return 'row-move-switch'
        }
      },
      // 恢复默认
      onResetDefault() {
        this.columns.forEach((e,index) => {
          e.order = (+index + 1)
          e.align='left',
          e.show=true,
          e.freeze=false
        })
        this.columns.sort((a, b) => a.order - b.order)
      },
      onShowAll(){
        this.columns.forEach(e => {
          e.show=true
        })
      },
      onShowColumn(e){
        console.log('>>',e)
      },
      onFreezeAll(){
        this.columns.forEach(e => {
          e.freeze=false
        })
      },
      onFreeze(status,order){
        console.log('>>',status,order)
        // 最多只能冻结8列
        if(order>8){
          this.$message.warning('冻结列数限制在8列')
          const currentItem = this.columns.find(item => item.order === order)
          if (currentItem) {
            currentItem.freeze = false
          }
        } else {
          if (status) {
            // order小于等于8时
            this.columns.forEach(item => {
              if (item.order <= order) {
                item.freeze = true
              }
            })
          }else {
            this.columns.forEach(item => {
              if (item.order >= order && item.order <= 8) {
                item.freeze = false
              }
            })
          }
          
        }
      },
      // 下移
      onDown(index) {
          this.columns[index].move = 1
          this.columns[index+1].move = 2
          this.columns[index].order += 1
          this.columns[index + 1].order -= 1
          this.columns.sort((a, b) => a.order - b.order)
          setTimeout(() => {
            this.columns[index+1].move = 0 
            this.columns[index].move = 0 
          }, 500)
      },
      onUp(index) {
          this.columns[index].move = 1
          this.columns[index-1].move = 2
          this.columns[index].order -= 1
          this.columns[index - 1].order += 1
          this.columns.sort((a, b) => a.order - b.order)
          setTimeout(() => {
            this.columns[index-1].move = 0
            this.columns[index].move = 0
          }, 500)
      },
      // 确认修改
      onConfirm() {
        this.$emit('hasSetTable', this.columns)
        sessionStorage.setItem('saleOrderTable', this.columns)
        this.visibleDialog = false
        let postData = {
          jsonPayload: JSON.stringify(this.columns)
        }
        this.$api.omsFormSave(postData)
      },
    },
  }
</script>
<style lang='scss'>
.pop-set-table{
 .table-list-top{
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  
  height: 37px;
  line-height: 37px;
  .primary{
    cursor: pointer;
  }
  .space{
    font-size: 11px;
    color: #EFEFEF;
    display: inline-block;
    padding: 0 11px;
  }
 }
 .table-list{
  height: 330px;
  overflow-y: auto;
  scrollbar-width: thin;
  .select-align{
    width: 80px;
    .el-input__inner{
      padding: 0 10px 0 7px;
      text-align: left;
    }
  }
 }
  .btn-con{
    display: flex;
    .primary{
      cursor: pointer;
    }
    .primary+.primary{ 
      margin-left: 24px;
    }
  }
  // 添加行样式
  .el-table {
    .el-table__row{
      transition: .2s;
    }
    .row-move{
      background-color: #FCEDED;
      .el-switch__core:after{
        transition: none;
      }
    }
    .row-move-switch{
        .el-switch__core:after{
        transition: none;
      }
    }
    
    // 可以根据需要添加更多样式
  }
}
</style>